<template>
  <div id="header">
    <div class="container">
      <div class="row">
        <!--div class="col-12 mt-2">
          <div class="alert alert-danger d-flex align-items-center justify-content-center fw-bold" role="alert" style="font-size: 1.2rem;">
            <i class="fa-solid fa-triangle-exclamation fa-2x me-3 text-danger pulse-icon"></i>
            Entorn de PRE-PRODUCCIÓ
          </div>
        </div>-->

        <div class="col-xl-6 text-left mt-3">
          <!--a href="https://apren.upc.edu" rel="noreferrer noopener" class="me-2">
            <img src="@/assets/images/logo-apren.png" width="50" alt="Universitat Politècnica de Catalunya" title="Universitat Politècnica de Catalunya">
          </a-->
          <a href="https://www.upc.edu" target="_blank" rel="noreferrer noopener" class="me-4" style="display: inline-block; vertical-align: top;">
            <img src="@/assets/images/logo.png" alt="Universitat Politècnica de Catalunya" title="Universitat Politècnica de Catalunya" style="vertical-align: top;">
          </a>
          <a href="https://www.upc.edu" target="_blank" rel="noreferrer noopener" style="display: inline-block; vertical-align: top;">
            <img src="@/assets/images/logo-apren2.png" alt="Universitat Politècnica de Catalunya" title="Universitat Politècnica de Catalunya" style="max-width: 130px; height: auto; vertical-align: top;">
          </a>
        </div>

        <!-- ============================================================== -->
        <!-- Top menu: -->
        <!-- ============================================================== -->
        <div class="col-xl-6 container text-end">
          <ul id="top-menu" class="d-lg-block d-md-none d-sm-none d-xs-none">

            <!--li class="fw-bold">
              <router-link-locale :to="{name: 'home'}">
                <i class="fa-regular fa-user"></i> login
              </router-link-locale>
            </li-->

            <li>
              <a href="https://futur.upc.edu" target="_blank" rel="noreferrer noopener" aria-label="Info">
                <img :src="require('@/assets/images/logo-futur-nou.png')" alt="Futur: portal producción científica" style="max-width: 50px; height: auto; vertical-align: top;">
              </a>
            </li>


            <li>
              <router-link-locale :to="{name: 'publish'}" aria-label="Info">
                <i class="fa-regular fa-circle-question"></i> {{$t('Com publicar')}}
              </router-link-locale>

            </li>

            <li>
              <router-link-locale :to="{name: 'news'}" aria-label="News">
                <i class="fa-solid fa-newspaper"></i> {{$t('news.title')}}
              </router-link-locale>
            </li>

            <li>
              <router-link-locale :to="{name: 'about'}" :aria-label="$t('Sobre')">
                <i class="fa-solid fa-info"></i>
              </router-link-locale>
            </li>

            <li>
              <router-link-locale :to="{name: 'contact'}" :aria-label="$t('Contacte')">
                <i class="fa-regular fa-envelope"></i>
              </router-link-locale>
            </li>



            <li>
              <div style="display: inline-block;">
              <el-dropdown trigger="hover" class="nav-link dropdown-toggle">
                <span class="el-dropdown-link">
                  <span class="text-secondary"><i class="fa-solid fa-globe"></i> {{$i18n.locale === 'es' ? $t('Español') : $i18n.locale === 'ca' ? $t('Català') : $t('English')}} </span>
                </span>
                <template #dropdown>
                  <el-dropdown-menu class="language-selector">
                    <el-dropdown-item v-for="id in $i18n.availableLocales" :key="id" @click="changeLocale(id)">
                      <a role="menuitem" :class="{selected: $i18n.locale===id}" href="#">{{ id === 'es' ? $t('Español') : id === 'ca' ? $t('Català') : $t('English') }}</a>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
              </div>
            </li>


          </ul>

          <!-- ============================================================== -->
          <!-- Top menu 2: -->
          <!-- ============================================================== -->


          <!--ul id="top-menu2" class="d-lg-block d-md-none d-sm-none d-xs-none">
            <li><router-link-locale :to="{name: 'professorat', params: {page: 1, sort: 'professor_nom_sort asc'}}">{{$t('Professorat').toUpperCase()}}</router-link-locale></li>
            <li><router-link-locale :to="{name: 'organitzacions', params: {page: 1, sort: 'organitzacio_nom_ca asc'}}">{{$t('Organització').toUpperCase()}}</router-link-locale></li>
            <li><router-link-locale :to="{name: 'assignatures', params: {page: 1, sort: 'assignatura_nom_ca asc'}}">{{$t('Assignatures').toUpperCase()}}</router-link-locale></li>
            <li><router-link-locale :to="{name: 'titulacions', params: {page: 1, sort: 'titulacio_sigles asc'}}">{{$t('Titulacions').toUpperCase()}}</router-link-locale></li>
          </ul-->

        </div>

      </div>



      <div class="row mb-2 mt-4">

        <a :href="'https://apren.upc.edu/'+$i18n.locale" style="text-decoration: none;">
          <div class="d-flex align-items-center">
            <span class="h3 me-1 text-muted fw-bold">
              APRÈN.
            </span>
            <span class="h4 mt-1 text-secondary">
              {{$t('Portal de la producció docent del professorat de la UPC')}}
            </span>
          </div>
        </a>

      </div>

    </div>

    <!-- ============================================================== -->
    <!-- Main menu TODO canviar para adaptarlo a mobile -->
    <!-- ============================================================== -->

    <!--div id="main-menu" class="main-background"-->
    <div id="main-menu" :style="{ backgroundImage: `url(${backgroundImage})` }">

      <div class="container">
        <div class="row">
          <div class="col-sm-12 mt-5 mb-5">
            <div class="d-flex flex-wrap justify-content-center align-items-center">

              <router-link-locale :to="{name: 'professorat', params: {page: 1, sort: 'professor_nom_sort asc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/professorat/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-users fa-2x mb-2"></i>
                  <span class="text">{{$t('Professorat')}}</span>
                  <span class="number">{{dataHeader.num_professor}}</span>
                </div>
              </router-link-locale>

              <router-link-locale :to="{name: 'organitzacions', params: {page: 1, sort: 'organitzacio_nom_ca asc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/organitzacions/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fa-regular fa-building fa-3x mb-2"></i>
                  <span class="text">{{$t('Organització')}}</span>
                  <span class="number">{{dataHeader.num_organitzacio}}</span>
                </div>
              </router-link-locale>

              <router-link-locale :to="{name: 'assignatures', params: {page: 1, sort: 'assignatura_nom_ca asc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/assignatures/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-sitemap fa-2x mb-2"></i>
                  <span class="text">{{$t('Assignatures')}}</span>
                  <span class="number">{{dataHeader.num_assignatura}}</span>
                </div>
              </router-link-locale>

              <router-link-locale :to="{name: 'titulacions', params: {page: 1, sort: 'titulacio_sigles asc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/titulacions/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-user-graduate fa-2x mb-2"></i>
                  <span class="text">{{$t('Titulacions')}}</span>
                  <span class="number">{{dataHeader.num_titulacio}}</span>
                </div>
              </router-link-locale>

              <router-link-locale :to="{name: 'activitats', params: {page: 1, sort: 'data desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/activitats/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-university fa-2x mb-2"></i>
                  <span class="text">{{$t('Activitats')}}</span>
                  <span class="number">{{(toInteger(dataHeader.num_activitat)+toInteger(dataHeader.num_material)).toLocaleString() }} </span>
                </div>
              </router-link-locale>

              <!--router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/materials/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2"-->
              <router-link-locale :to="{name: 'innovacio', params: {page: 1, sort: 'data desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/innovacio/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-file fa-2x mb-2"></i>
                  <span class="text">{{$t('Innovacio')}}</span>
                  <span class="number">{{toInteger(dataHeader.num_innovacio).toLocaleString()}}</span>
                </div>
              </router-link-locale>

              <!--router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/materials/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2"-->
              <router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/materials/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-file fa-2x mb-2"></i>
                  <span class="text">{{$t('subtipus')}}</span>
                  <span class="number">{{toInteger(dataHeader.num_material).toLocaleString()}}</span>
                </div>
              </router-link-locale>

              <router-link-locale :to="{name: 'accesObert', params: {page: 1, sort: 'data desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/accesObert/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-lock-open fa-2x mb-2"></i>
                  <span class="text">{{$t('Accés Obert')}}</span>
                  <span class="number">{{dataHeader.num_openAccess}}</span>
                </div>
              </router-link-locale>

              <router-link-locale :to="{name: 'treballsFinals', params: {page: 1, sort: 'data desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/treballsFinals/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-graduation-cap fa-2x mb-2"></i>
                  <span class="text">{{$t('Treballs Finals')}}</span>
                  <span class="number">{{dataHeader.num_pfc}}</span>
                </div>
              </router-link-locale>

              <router-link-locale :to="{name: 'videos', params: {page: 1, sort: 'data desc'}}" accesskey="" :class="{ 'active': $route.path.indexOf('/videos/') !== -1 }" class="d-flex main-menu-element align-items-center mb-2">
                <div class="content">
                  <i style="color: #5fa728;" class="fas fa-video fa-2x mb-2"></i>
                    <span class="text">{{$t('Vídeos')}}</span>
                  <span class="number">{{dataHeader.num_video}}</span>
                </div>
              </router-link-locale>

              <!-- Highlighted Mejoras Aprèn 2.0 -->
              <router-link-locale :to="{name: 'news'}" accesskey="" :class="{ 'active': $route.path.indexOf('/news') !== -1 }" class="d-flex main-menu-element main-menu-element-innovation align-items-center mb-2">
                <div class="content">
                  <i class="fas fa-wand-magic-sparkles fa-2x mb-2"></i>
                  <span class="text">{{$t('news.title')}}</span>
                </div>
              </router-link-locale>

              <!--a href="https://futur.upc.edu" target="_blank" rel="noreferrer noopener" style="background: #bfe5f4;" class="d-flex main-menu-element align-items-center mb-2">

                <div class="content" >
                  <img :src="require('@/assets/images/futur-bola.png')" alt="Futur: portal producción científica" class="mb-2" >
                  <span class="text">Futur</span>
                </div>
              </a-->

            </div>
          </div>
        </div>
      </div>
    </div>


    <SearcherSection></SearcherSection>



  </div>


</template>

<script>

import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import SearcherSection from "@/components/sections/SearchSection.vue";
import {useStore} from "vuex";
import {computed, onMounted, ref} from "vue";
import HeaderService from "@/services/HeaderService";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";
import router from "@/router";
import {toInteger} from "lodash-es";

export default {
  name: "HeaderSection",
  methods: {toInteger},
  components: {SearcherSection, RouterLinkLocale},

  setup(){

    const route = useRoute();
    const dataHeader = ref({})
    const store = useStore();

    const { locale } = useI18n();
    const selectedLocale = ref(locale.value);

    const changeLocale = (idLocale) => {
      locale.value = idLocale;
      const pathWithoutLocale = route.fullPath.substring(3);
      const query = route.query;
      router.push({ path: `/${locale.value}${pathWithoutLocale}`, query });
    };

    const reset = () => {
      store.dispatch('reset');
    };

    // get background image from Vuex state
    const backgroundImage = computed(() => store.getters.backgroundImage(route.name));

    onMounted(async () => {
      dataHeader.value = await HeaderService.getHeaderInfo()
    });

    const isActive = (routePrefix) => {
      const regex = new RegExp(`^/(es|ca|en)?${routePrefix}`);
      return computed(() => regex.test(route.path));
    };


    return{
      reset,
      backgroundImage,
      dataHeader,
      isActive,
      selectedLocale,
      changeLocale,
    }

  }


}

</script>

<style scoped>

.pulse-icon {
  animation: pulse-danger 1.5s infinite;
}

@keyframes pulse-danger {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.15); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
}

.active {
  background-color: #dfec9c !important;
}

#main-menu {
  width: 100%;
  background-size: cover;
  display: flex;
  align-items: center;
  position: relative;

  a.main-menu-element {
    height: 105px;
    width: 105px;
    border-radius: 50%;
    background: #e6f0f4;
    background: rgba(255,255,255,.9);
    border: 1px;
    font-size: 2rem;
    text-align: center;
    font-weight: 500;
    padding: 0;
    margin-right: 6px;
    text-decoration: none;
    justify-content: center;

    &:hover {
      background-color: #fff;
    }

    .active {
      background-color: #E4E7A1;
    }

    div.content {
      span.text {
        color: #000;
        font-size: 0.88rem;
        text-decoration: none;
        display: block;
      }

      i {
        font-size: 1.8rem;
        display: block;
        margin-bottom: 5px;
        color: #5fa728;
        /*color: #278AA2;e2ab17*/
      }

      span.number {
        display: block;
        font-size: 0.88rem;
        margin-top: 3px;
        font-weight: 500;
        color: #880404;
      }
    }
  }

  /* Highlighted Innovation/Mejoras Bola */
  a.main-menu-element-innovation {
    background: linear-gradient(135deg, #5fa728 0%, #1a1a2e 100%) !important;
    border: 2px solid #5fa728;
    box-shadow: 0 4px 15px rgba(95, 167, 40, 0.4);
    animation: pulse-glow 2s ease-in-out infinite;
    position: relative;
    overflow: visible;

    &:hover {
      background: linear-gradient(135deg, #4d8a20 0%, #0d0d1a 100%) !important;
      box-shadow: 0 6px 20px rgba(95, 167, 40, 0.5);
      transform: scale(1.05);
    }

    &.active {
      background: linear-gradient(135deg, #4d8a20 0%, #0d0d1a 100%) !important;
    }

    div.content {
      i {
        color: #fff !important;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
      }

      span.text {
        color: #fff !important;
        font-weight: 600;
      }
    }
  }

  @keyframes pulse-glow {
    0%, 100% {
      box-shadow: 0 4px 15px rgba(95, 167, 40, 0.4);
    }
    50% {
      box-shadow: 0 4px 25px rgba(95, 167, 40, 0.6);
    }
  }
}
/*
////////////////////////////////////////////

    Header and top menu

////////////////////////////////////////////
*/

#header {
  font-family: 'Roboto', Helvetica, serif !important;
  position: relative;
  width: 100%;
  background-color: #fff;
  top: 0;
  z-index: 99;

  #top-menu {
    margin-top: 0;
    font-size: 13px;

    & i {
      font-size: 1.125rem;
      color: #b2b2b2;
      vertical-align: middle;
    }

    & > li {
      display: inline-block;
      vertical-align: middle;
      margin-right: 12px;

      & > a {

        font-family: 'Roboto', sans-serif;
        font-size: 13px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;

        color: #636363;
        padding: 5px 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px; /* Balanced space between icon and text */
        min-width: 32px;
        min-height: 32px;
        border-radius: 2px;

        transition: all .25s ease;
        text-decoration: none;
      }

      & > a:hover {
        color: #007BC1;
        box-shadow: 0 0 3px rgba(0,0,0,0.33) !important;
        border-radius: 2px;
        transition: all .25s ease;
        text-decoration: none;
      }

      & > a:focus {
        box-shadow: none;
        text-decoration: none !important;
        outline-color: transparent;
      }
    }

    /* Unify Language Selector styles */
    .nav-link.dropdown-toggle {
      padding: 5px 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      transition: all .25s ease;
      border-radius: 2px;
      cursor: pointer;
      border: none !important;
      outline: none !important;
      box-shadow: none;
      
      /* Target the internal element that often gets focus in Element Plus */
      .el-dropdown-link, .el-dropdown-link:focus, .el-dropdown-link:active, span:focus {
        outline: none !important;
        border: none !important;
        box-shadow: none !important;
      }
      
      .text-secondary {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        color: #636363 !important;
        font-weight: 300;
        transition: all .25s ease;
        outline: none !important;
        
        i {
          color: #b2b2b2;
          transition: all .25s ease;
        }
      }

      &:hover, &:focus, &:active {
        box-shadow: 0 0 3px rgba(0,0,0,0.33) !important;
        background: transparent !important;
        outline: none !important;
        
        .text-secondary {
          color: #007BC1 !important;
          i {
            color: #007BC1;
          }
        }
      }
    }

    /* Global override for element-plus dropdown focus */
    :deep(.el-dropdown:focus), :deep(.el-tooltip__trigger:focus) {
      outline: none !important;
    }




    .dropdown-menu {
      min-width: 7rem;

      & > a {
        font-size: 0.8125rem;
        font-weight: 300;
        text-transform: none;
        padding: 7px 12px;

        &.active {
          font-weight: bold;
          background-color: #f5f5f5;
          color: #666;
        }
      }
    }
  }

  #top-menu2 {
    margin-top: 0;
    font-size: 16px;

    & i {
      font-size: 1.125rem;
      margin-right: 7px;
      vertical-align: bottom;
    }

    & > li {
      display: inline;

      & > a {
        color: #007BC1;
        font-weight: 700;
        font-size: 15px;
        padding: 3px 12px;
        display: inline-block;
        border-radius: 2px;
        transition: all .25s ease;
        text-decoration: none;
      }

      & > a:hover {
        color: #01559b;
        box-shadow: 0 0 3px rgba(0,0,0,0.33) !important;
        border-radius: 2px;
        transition: all .25s ease;
        text-decoration: none;
      }

      & > a:focus {
        box-shadow: none;
        text-decoration: none !important;
        outline-color: transparent;
      }
    }

    .dropdown-menu {
      min-width: 7rem;

      & > a {
        font-size: 0.8125rem;
        font-weight: 300;
        text-transform: none;
        padding: 7px 12px;

        &.active {
          font-weight: bold;
          background-color: #f5f5f5;
          color: #666;
        }
      }
    }
  }
}

</style>
